import { makeStyles } from '@mui/styles';
import { colors, typography as typographyTokens, radii } from '@components/design-system/tokens';

export const useStyles = makeStyles((theme: any) => ({
    headerItemWrapper: {
        margin: '0 2px',
    },
    headerItem: {
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: `${radii.md}px`,
        color: colors.neutral[600],
        fontSize: typographyTokens.fontSize.sm,
        fontWeight: typographyTokens.fontWeight.medium,
        textTransform: 'none',
        textDecoration: 'none',
        padding: '8px 12px',
        transition: 'all 150ms ease',

        '& svg': {
            fontSize: '20px !important',
            marginRight: 6,
        },

        [theme.breakpoints.up('lg')]: {
            '&:hover': {
                backgroundColor: colors.neutral[100],
                color: colors.neutral[900],
            },
        },

        [theme.breakpoints.down('md')]: {
            margin: '8px 0',
            padding: '10px 12px',
        },
    },
    headerItemActive: {
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: `${radii.md}px`,
        color: colors.primary[600],
        backgroundColor: colors.primary[50],
        fontSize: typographyTokens.fontSize.sm,
        fontWeight: typographyTokens.fontWeight.semibold,
        textTransform: 'none',
        textDecoration: 'none',
        padding: '8px 12px',
        transition: 'all 150ms ease',

        '& svg': {
            fontSize: '20px !important',
            marginRight: 6,
            color: colors.primary[600],
        },

        [theme.breakpoints.up('lg')]: {
            '&:hover': {
                backgroundColor: colors.primary[100],
            },
        },

        [theme.breakpoints.down('md')]: {
            margin: '8px 0',
            padding: '10px 12px',
        },
    },
    headerMenu: {
        display: 'flex',
        flex: 1,
        listStyleType: 'none',
        alignItems: 'center',
        margin: 0,
        padding: 0,
        gap: 4,
        [theme.breakpoints.down('lg')]: {
            display: 'none',
        },
    },
    headerMenuMobile: {
        display: 'flex',
        flex: 1,
        listStyleType: 'none',
        flexDirection: 'column',
        margin: 0,
        padding: 0,
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
    },
}));
